import { IPackSizeConstraint } from "src/core/shared/store/global/global.reducer";

import { IOrderLine } from "../api/orders.api";

/** Object of constraint with min/max settings along with sum total of qty */
export interface PackSizeConstraintWithPluralandQuantity extends IPackSizeConstraint {
  /** plural text display of code */
  plural?: string;
  /** sum total of qty on order */
  quantity: number;
}

/**
 * Loops through the pack size constraints and build array of pack size constraints relevant to the order
 * with a sum of the pack size quantity.
 *
 * If code weight found, quantity on the weight constraint is the sum total of weight of the order.
 * @param packSizeQuantities
 * @param orderLines
 * @returns
 */
export const packSizeConstraints = (packSizeQuantities: IPackSizeConstraint[], orderLines: IOrderLine[]) => {
  return packSizeQuantities.reduce((packSizeConstraints, packSizeQuantity): PackSizeConstraintWithPluralandQuantity[] => {
    if (packSizeQuantity.code === "weight") {
      // sum the weight of the order
      const totalOrderWeight = orderLines?.reduce((totalWeight, orderLine) => (
        totalWeight += orderLine.product?.weight ? orderLine.product.weight * orderLine.quantity : 0
      ), 0);

      // add and return constraint
      packSizeConstraints.push({
        ...packSizeQuantity,
        quantity: totalOrderWeight || 0
      });

      return packSizeConstraints;
    }

    // loop through order lines
    for (const orderLine of orderLines) {
      // get the relevant products pack size data
      const productPackSize = orderLine.product?.packSizes?.find(packSize => packSize.code === packSizeQuantity.code);
      // check if this pack size has already been added to the array
      const packSizeConstraintIndex = packSizeConstraints.findIndex(packSizeConstraint => packSizeConstraint.code === packSizeQuantity.code);

      // if the product has the relevant pack size or it aligns with the products unit code, alter the array
      if (productPackSize || packSizeQuantity.code === orderLine.product?.unitCode) {
        // if the pack size hasn't been added to the array then add it alogn with a quantity and plural
        // otherwise just update the quantity
        if (packSizeConstraintIndex === -1) {
          packSizeConstraints.push({
            ...packSizeQuantity,
            plural: productPackSize?.namePlural ? productPackSize?.namePlural.toLowerCase() : orderLine.product?.unitCodePlural || `${packSizeQuantity.code}s`,
            quantity: orderLine.quantity / (productPackSize?.quantity || 1)
          });
        } else {
          packSizeConstraints[ packSizeConstraintIndex ].quantity += orderLine.quantity / (productPackSize?.quantity || 1);
        }
      }
    }

    return packSizeConstraints;
  }, [] as PackSizeConstraintWithPluralandQuantity[]);
};
